<template>
  <!-- Mobile header -->
  <MobileHeader v-if="isMobile" />

  <!-- Desktop header -->
  <template v-else>
    <div class="sticky top-0 z-50">
    <TopHeader class="relative z-[21] print:hidden" />
    <BottomHeader v-if="!hiddeBottomHeader && isAuthenticated" class="border-b border-table print:hidden" />
    </div>
  </template>

  <div class="hidden items-start justify-between print:flex">
    <VcImage :src="logoUrl" :alt="$context.storeName" class="h-12" />

    <Created />
  </div>
</template>

<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import { useWhiteLabeling } from "@/core/composables";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useUser } from "@/shared/account";
import Created from "../print/created.vue";
import BottomHeader from "./_internal/bottom-header.vue";
import MobileHeader from "./_internal/mobile-header.vue";
import TopHeader from "./_internal/top-header.vue";

const breakpoints = useBreakpoints(breakpointsTailwind);
const { logoUrl } = useWhiteLabeling();
const route = useRoute();
const { isAuthenticated} = useUser();

// For optimization on mobile devices
const isMobile = breakpoints.smaller("lg");

const hiddenRoutes = ["SignIn", "SignUp", "ForgotPassword"];
const hiddenPaths = ["/sign-in", "/sign-up", "/forgot-password"]

const hiddeBottomHeader = computed(() => hiddenRoutes.includes(String(route.name)) || hiddenPaths.includes(route.path));

</script>
